import type { HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export type PanelElement = "article" | "aside" | "div" | "section";

export function Panel({
  as: Component = "div",
  className,
  ...props
}: HTMLAttributes<HTMLElement> & { as?: PanelElement }) {
  return <Component className={cn("sqk-panel", className)} {...props} />;
}

export function PanelHeader({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <header className={cn("sqk-panel__header", className)} {...props} />;
}

export function PanelTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("sqk-panel__title", className)} {...props} />;
}

export function PanelDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("sqk-panel__description", className)} {...props} />;
}

export function PanelContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("sqk-panel__content", className)} {...props} />;
}

export function PanelFooter({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <footer className={cn("sqk-panel__footer", className)} {...props} />;
}
